export default __webpack_public_path__ + "static/poster-12612582963e7ccc76aa35e778dda741.jpg";